<template>
  <v-dialog
    v-model="dialog"
    width="500"
  >
    <template v-slot:activator="{ props }">
      <slot
        v-if="showInfo"
        v-bind="{ props }"
      />
      <slot v-else />
    </template>

    <v-card class="d-flex flex-column">
      <v-card-title class="pa-0">
        <v-toolbar
          color="primary"
          dark
          flat
        >
          <v-toolbar-title>{{ $t('upgrade-info.title') }}</v-toolbar-title>
        </v-toolbar>
      </v-card-title>

      <v-card-text class="mt-8">
        <div>
          {{ $t('alerts.upselling.upgrade.0') }}
          <!-- Use wrapper span to track the event as @click is not called on <router-link> -->
          <span @click="$tracking.event('UpgradeInfoDialog', 'Clicked', 'Upgrade')">
            <a
              v-if="isPlatformSmg"
              :href="helpArticleLink"
              target="_blank"
              rel="noopener noreferrer"
              style="color: #ffffff"
            >
              {{ $t('alerts.upselling.upgrade.link') }}
            </a>
            <router-link
              v-else
              class="pointer font-weight-bold"
              :to="upgradeLink"
            >
              {{ $t('alerts.upselling.upgrade.link') }}
            </router-link>
          </span>
          {{ $t('alerts.upselling.upgrade.1') }}
        </div>
      </v-card-text>

      <v-card-actions class="d-flex justify-space-between">
        <v-btn
          variant="text"
          @click="dialog = false"
        >
          {{ $t('buttons.content-creator.close') }}
        </v-btn>
        <v-btn
          variant="text"
          color="primary"
          @click="handleUpgradeClick"
        >
          {{ $t('upgrade-info.title') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import brandingMixin from '@/mixins/branding.js'

export default {
  mixins: [brandingMixin],
  props: {
    showInfo: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialog: false,
    }
  },
  computed: {
    helpArticleLink() {
      return this.upgradePackageUrl
    },
    upgradeLink() {
      return {
        name: 'Settings',
        params: { section: 'contract' },
        query: { showUpgrade: '1' },
      }
    },
  },
  methods: {
    handleUpgradeClick() {
      this.$tracking.event('UpgradeInfoDialog', 'Clicked', 'Upgrade')

      if (this.isPlatformSmg) {
        window.open(this.upgradePackageUrl, '_blank')
        return
      }

      this.$router.push(this.upgradeLink)
    },
  },
}
</script>
